// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"wi","centerLink":"xi","productSection":"yi","item":"zi","ctaButton":"Ai"};